import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import { columntype, inputType, isValidArray } from "src/helper/publicFunction";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  ManageSubServicesMediaGallery,
  DeleteEventsMediaGallery,
  GetSubServicesMediaGallery,
} from "./actions";
import { useParams } from "react-router";
import { GetSubServices } from "../sub_services/actions";

const SubServicesMediaGallery = () => {
  const { id } = useParams();
  console.log(id);
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [subServiceOptions, setSubServiceOptions] = useState([]);
  const [showCoverField, setShowCoverField] = useState(false);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);

  const Schema = Yup.object().shape({
    // type_name: Yup.string().trim().required("required"),
  });

  const isPdfFile = (fileValue) => {
    if (!fileValue) {
      return false;
    }

    let candidate = fileValue;

    if (Array.isArray(fileValue)) {
      candidate = fileValue[0];
    } else if (
      typeof FileList !== "undefined" &&
      fileValue instanceof FileList
    ) {
      candidate = fileValue[0];
    }

    const fileType =
      candidate && typeof candidate.type === "string"
        ? candidate.type.toLowerCase()
        : "";

    if (fileType.includes("pdf")) {
      return true;
    }

    const fileName =
      typeof candidate === "string"
        ? candidate
        : candidate && typeof candidate.name === "string"
          ? candidate.name
          : "";

    return fileName.toLowerCase().endsWith(".pdf");
  };

  const GetData = ({ tableName = null, type = null }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetSubServicesMediaGallery({
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setTotalData(data?.count);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    dispatch(
      GetSubServices({
        page: 0,
        rowsPerPage: 500,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setSubServiceOptions(data?.data);
          } else {
            setSubServiceOptions([]);
          }
        },
      })
    );
  };

  const modalFields = useMemo(() => {
    const fields = [
      {
        failed: "id",
        type: inputType.text,
        title: "id",
        placeholder: "",
        fullwidth: true,
        customdesign: { display: "none" },
      },
      {
        failed: "video_time",
        type: inputType.text,
        title: "Video Time",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
      },
      {
        failed: "title",
        type: inputType.text,
        title: "Title",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
      },
      {
        failed: "description",
        type: inputType.text,
        title: "Description",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
      },
      {
        failed: "order_number",
        type: inputType.number,
        title: "Order Number",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
      },
      {
        failed: "sub_service_id",
        type: inputType.dropdown,
        title: "Sub Service",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
        datadropdown: subServiceOptions,
        faileddropdown: {
          name: "name",
          value: "id",
        },
      },
      {
        failed: "media",
        type: inputType.image,
        title: "Image",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
      },
    ];

    if (showCoverField) {
      fields.push({
        failed: "cover",
        type: inputType.image,
        title: "Cover Image",
        placeholder: "",
        fullwidth: true,
        customdesign: { width: "100%" },
      });
    }

    return fields;
  }, [showCoverField, subServiceOptions]);

  useEffect(() => {
    if (showModal) {
      setShowCoverField(isPdfFile(values?.media));
    } else {
      setShowCoverField(false);
    }
  }, [showModal, values?.media]);

  const handleModalFieldChange = ({ value, failedName, setFieldValue }) => {
    if (failedName !== "media") {
      return;
    }

    const isPdf = isPdfFile(value);

    setShowCoverField(isPdf);

    if (!isPdf) {
      setFieldValue("cover", "");
    }
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "video_time" },
    { type: columntype.text, name: "title" },
    { type: columntype.text, name: "order_number" },
    { type: columntype.image, name: "cover" },
    { type: columntype.text, name: "description" },
    { type: columntype.image, name: "media" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: false,
    },
    {
      id: "video_time",
      numeric: false,
      disablePadding: false,
      label: "Video Time",
      withSort: false,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "order_number",
      numeric: true,
      disablePadding: false,
      label: "Order Number",
      withSort: false,
    },
    {
      id: "cover",
      numeric: false,
      disablePadding: false,
      label: "Cover Image",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "media",
      numeric: false,
      disablePadding: false,
      label: "Media",
      withSort: false,
    },

    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.title ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteEventsMediaGallery({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaTypeId: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    {
      name: "Edit",
      function: async (row) => {
        if (row) {
          setEditMode(true);
          setvalues({
            ...row,
            id: row.id,
            sub_service_id: row.sub_service_id ?? "",
            order_number: row.order_number ?? "",
            media: row.media ?? "",
          });
          setShowModal(true);
        }
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(id) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteEventsMediaGallery({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      mediaTypeId: id,
                    })
                  ),

                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => { }} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={true}
        withDeleteItem={false}
        withEditItem={true}
        withPagination={false}
        withSearch={false}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={modalFields}
          values={values}
          title={"Media Gallery"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add new media gallery"}
          buttonTitle={editMode ? "Edit" : "Add"}
          onChange={handleModalFieldChange}
          onSubmit={(valuess) => {
            dispatch(
              ManageSubServicesMediaGallery({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default SubServicesMediaGallery;
